import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { FeatureProfile } from './feature-profile.model';
import { map } from 'rxjs/operators';

@Injectable()
export class FeatureProfileService {

  private FEATURE_PROFILES_URI = 'feature-profiles';

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<FeatureProfile[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.FEATURE_PROFILES_URI}`;
    return this.http.get(url, { headers })
      .pipe(
        map((profiles: any[]) => profiles.map(p => FeatureProfile.fromDto(p)))
      );
  }

  public create(profile: FeatureProfile): Observable<FeatureProfile> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.FEATURE_PROFILES_URI}`;

    return this.http.post(url, FeatureProfile.toDto(profile), { headers })
      .pipe(
        map(h => FeatureProfile.fromDto(h))
      );
  }

  public update(profile: FeatureProfile): Observable<FeatureProfile> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.FEATURE_PROFILES_URI}/${profile.id}`;

    return this.http.put(url, FeatureProfile.toDto(profile), { headers })
      .pipe(
        map(h => FeatureProfile.fromDto(h))
      );
  }

  public remove(id: string): Observable<any> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.FEATURE_PROFILES_URI}/${id}`;

    return this.http.delete(url, { headers });
  }

}
